"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enum = require("../../enum");
var _api = require("../api");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AddFund',
  data: function data() {
    return {
      dialogFormVisible: false,
      operationTypeEnum: _enum.operationTypeEnum,
      rules: {
        amount: [{
          required: true,
          message: '请输入金额',
          trigger: 'blur'
        }],
        changeType: [{
          required: true,
          message: '请选择变更类型',
          trigger: 'change'
        }]
      },
      formRef: null,
      form: {}
    };
  },
  methods: {
    open: function open(id) {
      this.form.customerId = id;
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.form = {};
      this.dialogFormVisible = false;
    },
    // 上传图片
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.$set(_this.form, 'extra', img);
      }, tit, 'store');
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          var params = _objectSpread({}, _this2.form);
          if (_this2.form.extra) {
            params.extra = _this2.form.extra.map(function (item) {
              return item.sattDir;
            }).join(',');
          }
          (0, _api.addFundsRecordsApi)(params).then(function () {
            _this2.$message.success('添加成功');
            _this2.close();
            _this2.$emit('refresh');
          });
        }
      });
    }
  }
};